<template>
  <div>
    <list-block>
      <el-form
        ref="formData"
        :rules="rules"
        :inline="true"
        :model="formData"
      >
        <h4 style="margin-bottom: 10px;">
          节点通用设置
        </h4>
        <el-row>
          <el-col :span="9">
            <el-form-item label="自动接单：" prop="acceptOrderAudit">
              <el-radio-group
                v-model="formData.acceptOrderAudit"
                :disabled="isDetail"
              >
                <el-radio
                  v-for="item in RETURN_LOCATION_OPTIONS"
                  :key="item.value"
                  :label="item.value"
                >
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="默认货品质量：" prop="useGoodsQuality">
              <el-radio-group
                v-model="formData.useGoodsQuality"
                :disabled="isDetail"
              >
                <el-radio
                  v-for="item in DEFAULT_QU_OPTIONS"
                  :key="item.value"
                  :label="item.value"
                >
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <prescription
              :time.sync="formData.executeMaxTime"
              :time-type.sync="formData.timeUnit"
              :disabled="isDetail"
            />
          </el-col>
        </el-row>
        <TaskSetting
          ref="taskTableEl"
          :node-index="1"
          :table-data="formData.ruleFlowTaskItemDetails"
        />
      </el-form>
    </list-block>
  </div>
</template>

<script>
import ListBlock from '@/components/ListBlock/index.vue';
import Prescription from '../../components/Prescription.vue';
import TaskSetting from './TaskSetting.vue';
import {
  enableShutdownState,
  RETURN_LOCATION_OPTIONS,
  DEFAULT_QU_OPTIONS,
  NODE_TYPE,
} from './constant';

export default {
  components: {
    ListBlock,
    Prescription,
    TaskSetting,
  },
  props: {
    formData: {
      type: Object,
      default: () => {},
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      RETURN_LOCATION_OPTIONS,
      enableShutdownState,
      DEFAULT_QU_OPTIONS,
      rules: {
        acceptOrderAudit: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        useGoodsQuality: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
      },
    };
  },
  methods: {
    // 纯获取数据
    getPureTableData() {
      return this.$refs.taskTableEl.getPureTableData();
    },
    resetTaskOptions() {
      return this.$refs.taskTableEl.resetTaskOptions();
    },
    validateForm() {
      /* eslint-disable-next-line */
      return new Promise(async (resolve) => {
        try {
          await this.$refs.formData.validate();
          const tableData = await this.$refs.taskTableEl.getTableData(1);
          resolve(tableData);
        } catch (error) {
          this.$message.warning(`请完善“${NODE_TYPE[1].label}”节点数据`);
        }
      });
    },
  },
};
</script>
